<template>
  <span class="signal-glyph" :class="sizeClass" aria-hidden="true">
    <svg v-if="resolvedName === 'runtime'" viewBox="0 0 48 48" fill="none">
      <rect x="9" y="9" width="30" height="30" rx="9" stroke="currentColor" stroke-width="2.2" />
      <path d="M16 24h16M24 16v16" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="24" cy="24" r="4.5" fill="currentColor" opacity="0.18" />
    </svg>

    <svg v-else-if="resolvedName === 'device'" viewBox="0 0 48 48" fill="none">
      <rect x="13" y="8" width="22" height="32" rx="7" stroke="currentColor" stroke-width="2.2" />
      <rect x="18" y="14" width="12" height="9" rx="2.5" stroke="currentColor" stroke-width="2.2" />
      <path d="M19 30h10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="24" cy="34" r="1.8" fill="currentColor" />
    </svg>

    <svg v-else-if="resolvedName === 'voice'" viewBox="0 0 48 48" fill="none">
      <rect x="16" y="8" width="16" height="21" rx="8" stroke="currentColor" stroke-width="2.2" />
      <path d="M24 29v8M18 37h12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <path d="M12 21c0 6.6 5.4 12 12 12s12-5.4 12-12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>

    <svg v-else-if="resolvedName === 'vision'" viewBox="0 0 48 48" fill="none">
      <path d="M6 24s6-10 18-10 18 10 18 10-6 10-18 10S6 24 6 24z" stroke="currentColor" stroke-width="2.2" />
      <circle cx="24" cy="24" r="6.3" stroke="currentColor" stroke-width="2.2" />
      <circle cx="24" cy="24" r="2.4" fill="currentColor" />
    </svg>

    <svg v-else-if="resolvedName === 'knowledge'" viewBox="0 0 48 48" fill="none">
      <rect x="10" y="11" width="12" height="16" rx="3" stroke="currentColor" stroke-width="2.2" />
      <rect x="26" y="21" width="12" height="16" rx="3" stroke="currentColor" stroke-width="2.2" />
      <path d="M22 19h4M19 29h10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="24" cy="19" r="2.1" fill="currentColor" />
      <circle cx="19" cy="29" r="2.1" fill="currentColor" />
      <circle cx="29" cy="29" r="2.1" fill="currentColor" />
    </svg>

    <svg v-else-if="resolvedName === 'touchless'" viewBox="0 0 48 48" fill="none">
      <path d="M10 30c3.5-8.4 8.7-13 14-13 5.3 0 10.5 4.6 14 13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <path d="M15 31c2.5-4 5.5-6.2 9-6.2 3.5 0 6.5 2.2 9 6.2" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" opacity="0.78" />
      <circle cx="24" cy="18" r="2.5" fill="currentColor" />
      <path d="M24 26v8M24 34l5 3" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>

    <svg v-else-if="resolvedName === 'ops'" viewBox="0 0 48 48" fill="none">
      <rect x="9" y="12" width="30" height="24" rx="7" stroke="currentColor" stroke-width="2.2" />
      <path d="M17 18v12M24 16v16M31 21v7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="17" cy="22" r="2.1" fill="currentColor" />
      <circle cx="24" cy="27" r="2.1" fill="currentColor" />
      <circle cx="31" cy="24" r="2.1" fill="currentColor" />
    </svg>

    <svg v-else-if="resolvedName === 'hybrid'" viewBox="0 0 48 48" fill="none">
      <path d="M15 31h18a7 7 0 0 0 0-14 9 9 0 0 0-17.5 2.2A6.4 6.4 0 0 0 15 31z" stroke="currentColor" stroke-width="2.2" />
      <path d="M19 24h10M24 19l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg v-else-if="resolvedName === 'patent'" viewBox="0 0 48 48" fill="none">
      <path d="M24 8 35 12v10.5c0 8-4.6 13.2-11 17.5C17.6 35.7 13 30.5 13 22.5V12L24 8Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" />
      <path d="M18.5 24H29.5M24 18.5v11" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="24" cy="24" r="3.6" fill="currentColor" opacity="0.16" />
    </svg>

    <svg v-else-if="resolvedName === 'paper'" viewBox="0 0 48 48" fill="none">
      <path d="M14 8h14l7 7v23a2 2 0 0 1-2 2H14a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4z" stroke="currentColor" stroke-width="2.2" />
      <path d="M28 8v8h8M17 24h12M17 30h12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="18" cy="18" r="2" fill="currentColor" />
    </svg>

    <svg v-else-if="resolvedName === 'team'" viewBox="0 0 48 48" fill="none">
      <circle cx="17" cy="18" r="4.5" stroke="currentColor" stroke-width="2.2" />
      <circle cx="31" cy="17" r="4" stroke="currentColor" stroke-width="2.2" />
      <path d="M10 33c1.5-4.5 4.9-7 9-7s7.5 2.5 9 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <path d="M25.5 32c1.1-3.3 3.8-5.2 7.1-5.2 2.7 0 5.1 1.3 6.4 3.9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>

    <svg v-else-if="resolvedName === 'contact'" viewBox="0 0 48 48" fill="none">
      <path d="M9 14h30v20a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4V14z" stroke="currentColor" stroke-width="2.2" />
      <path d="m11 16 13 9 13-9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="34" cy="14" r="3.5" fill="currentColor" opacity="0.22" />
    </svg>

    <svg v-else-if="resolvedName === 'user'" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="17" r="5.6" stroke="currentColor" stroke-width="2.2" />
      <path d="M13 35c2.1-5 6-7.7 11-7.7S32.9 30 35 35" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>

    <svg v-else-if="resolvedName === 'company'" viewBox="0 0 48 48" fill="none">
      <path d="M12 38V14h14v24M26 38V20h10v18M8 38h32" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18 20h.01M18 26h.01M18 32h.01M31 26h.01M31 31h.01" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    </svg>

    <svg v-else-if="resolvedName === 'tutorial'" viewBox="0 0 48 48" fill="none">
      <path d="M15 10h18a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4z" stroke="currentColor" stroke-width="2.2" />
      <path d="M18 18h12M18 24h12M18 30h8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      <circle cx="32" cy="30" r="4" fill="currentColor" opacity="0.2" />
    </svg>

    <svg v-else viewBox="0 0 48 48" fill="none">
      <circle cx="16" cy="16" r="3" fill="currentColor" />
      <circle cx="32" cy="16" r="3" fill="currentColor" />
      <circle cx="16" cy="32" r="3" fill="currentColor" />
      <circle cx="32" cy="32" r="3" fill="currentColor" />
      <path d="M19 16h10M16 19v10M29 32H19M32 29V19" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>
  </span>
</template>

<script>
const ALIASES = Object.freeze({
  core: 'runtime',
  platform: 'runtime',
  psic: 'user',
  intent: 'user',
  touchless: 'touchless',
  horizon: 'touchless',
  deviceops: 'ops',
  operations: 'ops',
  extension: 'hybrid',
  cloud: 'hybrid',
  aegis: 'patent',
  brevetto: 'patent',
  patent: 'patent',
  shield: 'patent',
  people: 'team',
  person: 'user',
  email: 'contact',
  mail: 'contact',
  docs: 'paper'
})

export default {
  name: 'SignalGlyph',
  props: {
    name: {
      type: String,
      default: 'runtime'
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    resolvedName() {
      const normalized = String(this.name || '').trim().toLowerCase()
      return ALIASES[normalized] || normalized || 'runtime'
    },
    sizeClass() {
      return ['sm', 'lg'].includes(this.size) ? this.size : 'md'
    }
  }
}
</script>

<style scoped>
.signal-glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 18px;
  border: 1px solid rgba(121, 222, 255, 0.18);
  background:
    radial-gradient(circle at 32% 24%, rgba(255, 255, 255, 0.12), transparent 38%),
    linear-gradient(160deg, rgba(12, 28, 47, 0.92), rgba(8, 18, 31, 0.78));
  color: var(--accent-cyan);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
}

.signal-glyph.sm {
  width: 2.05rem;
  height: 2.05rem;
  border-radius: 15px;
}

.signal-glyph.lg {
  width: 3rem;
  height: 3rem;
  border-radius: 20px;
}

.signal-glyph svg {
  width: 68%;
  height: 68%;
}
</style>
